// Motion 1.0 — vertical-band grouping for grouped reveal delays.
// Elements within the same vertical band reveal together (delay 0/0.08/0.16/0.24s)
// to avoid the "stairstep" feel when each element has its own per-index delay.

export function getRevealGroup(element, isMobile) {
  const layout = (element?.layout && element.layout[isMobile ? 'mobile' : 'desktop']) || {};
  // y is a fraction (0..1) in section-v1.
  const y = typeof layout.y === 'number' ? layout.y : 0;
  if (y < 0.25) return 0;
  if (y < 0.50) return 1;
  if (y < 0.75) return 2;
  return 3;
}

export function delayForGroup(group) {
  return Math.min((group || 0) * 0.08, 0.24);
}
